// contexts/TiposEntregaContext.js
import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext'; // Importa o contexto de alertas
import { useMessage } from '../geral/MessageContext'; // Importa o contexto de mensagens

const TiposEntregaContext = createContext();

export const useTiposEntrega = () => useContext(TiposEntregaContext);

export const TiposEntregaProvider = ({ children }) => {
    const [tiposEntrega, setTiposEntrega] = useState([]);
    const { showAlert } = useAlert(); // Acessa showAlert do AlertContext
    const { showMessage } = useMessage(); // Acessa showMessage do MessageContext

    const fetchTiposEntrega = useCallback(async () => {
        try {
            const result = await fetchData('/TipoEntrega'); // Endpoint para buscar tipos de entrega
            setTiposEntrega(result);            
        } catch (error) {
            console.error("Erro ao buscar tipos de entrega:", error);
            showMessage(`Erro ao buscar tipos de entrega! ${error?.message || error}`, 'danger');
        }
    }, []); // Sem dependências externas além da função fetchData

     useEffect(() => {
         fetchTiposEntrega();
     }, [fetchTiposEntrega]); 

    const addTipoEntrega = async (tipoEntrega) => {
        try {
            const result = await postData('/TipoEntrega', tipoEntrega);
            setTiposEntrega([...tiposEntrega, result]);
            showAlert('Tipo de entrega adicionado com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar tipo de entrega:", error);
            showMessage('Erro ao adicionar tipo de entrega!\n' + error, 'danger');
        }
    };

    const updateTipoEntrega = async (tipoEntrega) => {
        try {
            const result = await putData('/TipoEntrega', tipoEntrega);
            setTiposEntrega((tiposEntrega) =>
                tiposEntrega.map((te) => (te.id === result.id ? result : te))
            );
            showAlert('Tipo de entrega alterado com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar tipo de entrega:", error);
            showAlert('Erro ao alterar tipo de entrega!', 'danger');
        }
    };

    const deleteTipoEntrega = async (id) => {
        try {
            await deleteData('/TipoEntrega', { tipoEntregaId: id }); // Passa o ID como parâmetro
            setTiposEntrega(tiposEntrega.filter(te => te.id !== id));
            showAlert('Tipo de entrega excluído com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir tipo de entrega:", error);
            showAlert('Erro ao excluir tipo de entrega!', 'danger');
        }
    };

    return (
        <TiposEntregaContext.Provider value={{ tiposEntrega, addTipoEntrega, updateTipoEntrega, deleteTipoEntrega }}>
            {children}
        </TiposEntregaContext.Provider>
    );
};